import { ReactNode } from 'react'

interface InfoCellPairProps {
  testId: string
  title: string | ReactNode
  amount: string
  tag?: 'div' | 'h6'
  amountClassName?: string
  labelClassName?: string
}

export function InfoCellPair(props: InfoCellPairProps) {
  const Tag = props.tag ?? 'div'
  const amountClassName =
    props.amountClassName ?? 'fmc-type--body1 fds-color__text--gray3'

  return (
    <div className={'fds-flex fds-flex__justify--between'}>
      <Tag className={`fmc-type--body1 ${props.labelClassName}`}>
        {props.title}
      </Tag>
      <Tag
        className={`price-text fmc-pl-3 ${amountClassName}`}
        data-testid={props.testId}
      >
        {props.amount}
      </Tag>
    </div>
  )
}
